import { Input } from "shared/components/forms/Input";
import { ColorPicker } from "./components/ColorPicker";
import { LogoDropZone } from "./components/LogoDropZone";
import { getPropertyPresigned } from "../AddProperty/untils";
import { generatePrimaryPalette } from "./components/ColorPicker/untils";
import { uploadFileToS3Bucket } from "utils/fileHandlers";
import { SectionCard } from "shared/app/SectionCard";
import { useState } from "react";

interface BrandingFormProps {
  headerExtra?: React.ReactNode;
  footer?: React.ReactNode;
  register: any;
  sessionKey: string;
  onUploadingChange?: (isUploading: boolean) => void;
}

export const BrandingForm = ({
  register,
  sessionKey,
  headerExtra,
  footer,
  onUploadingChange
}: BrandingFormProps) => {
  const [isLogoUploading, setIsLogoUploading] = useState(false);
  const handleLogoSelect = async (file: File | null) => {
    if (!file) {
      register("logo").onChange(undefined);
      return;
    }

    try {
      setIsLogoUploading(true);
      onUploadingChange?.(true);
      const presigned = await getPropertyPresigned(file, sessionKey);
      await uploadFileToS3Bucket(presigned.response.url, file);
      register("logo").onChange(presigned.asset.global_id);
    } catch (error) {
      console.error("Error uploading logo:", error);
    } finally {
      setIsLogoUploading(false);
      onUploadingChange?.(false);
    }
  };

  const handleColorChange = (color: string) => {
    const palette = generatePrimaryPalette(color);
    register("primary_color").onChange(palette[500]);
    register("palette").onChange(palette);
  };

  return (
    <SectionCard title="Branding" headerExtra={headerExtra} footer={footer}>
      <div className="space-y-8">
        <div className="grid grid-cols-2 gap-6 items-center">
          <LogoDropZone
            onFileSelect={handleLogoSelect}
            logoUrl={register("logo").value}
            isUploading={isLogoUploading}
          />

          <ColorPicker
            value={register("primary_color").value || ""}
            onChange={handleColorChange}
            label="Primary color"
            placeholder="#E6007E"
            defaultValue="#E6007E"
          />
        </div>

        <div className="grid grid-cols-2 gap-6">
          <div>
            <Input
              id="landlord-name"
              label="Landlord name"
              placeholder="John Doe"
              maxLength={100}
              {...register("landlord_name")}
            />
          </div>

          <div>
            <Input
              id="landlord-phone"
              label="Landlord phone"
              placeholder="123-456-7890"
              type="tel"
              {...register("landlord_phone")}
            />
          </div>
        </div>
      </div>
    </SectionCard>
  );
};
